var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GameplanHeader = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Basic = require("../../../elements/Basic");

var _Match = _interopRequireDefault(require("../Match"));

var _PropsHelper = require("../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Gameplan/GameplanGroup.js";

var GameplanHeader = function GameplanHeader(_ref) {
  var scheduledStartTime = _ref.scheduledStartTime,
      headerStyle = _ref.headerStyle;
  return _react.default.createElement(_Basic.Row, (0, _extends2.default)({
    isFlex: true,
    justifyContent: "center",
    mt: 2,
    mb: 2
  }, (0, _get.default)(headerStyle, 'rowStyle'), {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 5
    }
  }), _react.default.createElement(_Basic.Text, (0, _extends2.default)({
    size: "custom",
    fontSize: 1
  }, (0, _get.default)(headerStyle, 'textStyle'), {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }), (0, _moment.default)(scheduledStartTime).format('dddd, DD.MM.YYYY')));
};

exports.GameplanHeader = GameplanHeader;

var GameplanGroup = function GameplanGroup(_ref2) {
  var rowLimit = _ref2.rowLimit,
      matches = _ref2.matches,
      onPress = _ref2.onPress,
      renderMatch = _ref2.renderMatch,
      createHref = _ref2.createHref,
      headerStyle = _ref2.headerStyle,
      NavWrapper = _ref2.NavWrapper;
  return _react.default.createElement(_Basic.Column, {
    pb: 2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 5
    }
  }, _react.default.createElement(GameplanHeader, {
    scheduledStartTime: matches[0].scheduledStartTime,
    headerStyle: headerStyle,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 9
    }
  }), matches.slice(0, rowLimit).map(function (match, index) {
    return renderMatch ? renderMatch(match, index) : _react.default.createElement(_Match.default, (0, _extends2.default)({
      key: match.id
    }, {
      match: match,
      onPress: (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onPress, match),
      href: (0, _PropsHelper.executeFunctionOrUndefined)(createHref, match),
      NavWrapper: NavWrapper
    }, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37,
        columnNumber: 17
      }
    }));
  }));
};

var _default = GameplanGroup;
exports.default = _default;